import { Earth } from './Earth';
import Phaser from 'phaser';

export class VolcanicEarth extends Earth {
  private reflectActive: boolean = false;
  private reflectPercent: number = 0.3;
  private reflectDuration: number = 4000;

  constructor(scene: Phaser.Scene, x: number, y: number) {
    // Call parent constructor with proper parameters
    super(scene, x, y, 800, 0.05, 10, 20000, 0);
    
    // Set specific properties
    this.damageResistance = 0.05;
    this.specialAbility = 'Reflect';
    this.abilityCooldown = 20000;
  }

  override useSpecialAbility(): void {
    this.activateReflect();
  }

  override activateAbility(): void {
    this.playAbilityEffect();
    this.activateReflect();
  }

  private activateReflect(): void {
    if (this.reflectActive) return;
    this.reflectActive = true;
    // Gắn cờ phản sát thương, sau 4s tắt
    this.scene.time.delayedCall(this.reflectDuration, () => {
      this.reflectActive = false;
    });
  }

  override takeDamage(amount: number): void {
    // Apply normal damage
    super.takeDamage(amount);
    
    // Apply reflect damage if active
    if (this.reflectActive) {
      this.reflectDamageToNearbyMonsters(amount);
    }
  }

  // Reflect damage to nearby monsters
  private reflectDamageToNearbyMonsters(amount: number): void {
    const reflectRadius = 150;
    const reflectDamage = amount * this.reflectPercent;
    
    this.scene.children.list.forEach(child => {
      if (child && typeof (child as any).takeDamage === 'function' && 
          child !== this && (child as any).x !== undefined && (child as any).y !== undefined) {
        const distance = Phaser.Math.Distance.Between(this.x, this.y, (child as any).x, (child as any).y);
        if (distance <= reflectRadius) {
          (child as any).takeDamage(reflectDamage);
        }
      }
    });
  }

  override upgrade(): void {
    this.level++;
    this.baseMaxHealth += 150;
    this.baseDefense += 0.01;
    this.damageResistance += 0.01;
    this.recalculateStats();
    this.health = this.effectiveMaxHealth;
  }

  override playAbilityEffect(): void {
    // Volcanic eruption effect
    for (let i = 0; i < 8; i++) {
      const angle = Math.random() * Math.PI * 2;
      const distance = 40 + Math.random() * 20;
      const x = this.x + Math.cos(angle) * distance;
      const y = this.y + Math.sin(angle) * distance;
      
      const lava = this.scene?.add.circle(x, y, 4, 0xff4500, 1);
      if (lava && this.scene?.tweens) {
        lava.setDepth(this.depth + 1);
        
        this.scene.tweens.add({
          targets: lava,
          y: y - 50,
          scaleX: 0.5,
          scaleY: 0.5,
          alpha: 0,
          duration: 1500,
          ease: 'Power2.easeOut',
          onComplete: () => lava.destroy()
        });
      }
    }
  }

  protected getAtmosphereColor(): number {
    return 0xff4500; // Orange red
  }

  protected getEnergyColor(): number {
    return 0xff6347; // Tomato
  }

  protected getParticleColor(): number {
    return 0xdc143c; // Crimson
  }

  protected getShieldColor(): number {
    return 0xff0000; // Red
  }

  protected getCoreColor(): number {
    return 0x8b0000; // Dark red
  }
} 